import {
  GET_CURRENT_USER_STARTED,
  GET_CURRENT_USER_COMPLETED,
  GET_CURRENT_USER_FAILED,
  CLEAR_STATES
} from '@/store/types'
import { marshalUser } from '@/utils/marshal'

import permissions from './current_user/permissions'
import tokens from './current_user/tokens'

function getDefaultState () {
  return {
    user: {
      id: -1
    },

    loading: false,
    error: undefined,
    actionError: undefined
  }
}

export default {
  namespaced: true,
  modules: {
    permissions,
    tokens
  },

  state: getDefaultState(),
  getters: {
    isLoggedIn: function (state) {
      return state.user.displayName !== undefined
    }
  },

  mutations: {
    // Get current user
    [GET_CURRENT_USER_STARTED] (state) {
      state.loading = true
    },
    [GET_CURRENT_USER_COMPLETED] (state, currentUser) {
      state.user = marshalUser(currentUser)
      state.loading = false
      state.error = undefined
    },
    [GET_CURRENT_USER_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async get ({ commit, rootState: { client = undefined } }) {
      try {
        commit(GET_CURRENT_USER_STARTED)
        const currentUser = await client.authClient.getCurrentUser()
        commit(GET_CURRENT_USER_COMPLETED, currentUser)
      } catch (err) {
        commit(GET_CURRENT_USER_FAILED, err)
      }
    }
  }
}
